<template>
    <div class="fx-g1 fx-col" v-loading="loading" element-loading-text="数据拼命加载中...">
        <div class="item_block fx fx-m_between info_row ">
            <el-form :inline="true" :model="form" >
                <el-form-item label="关键词">
                    <el-input v-model="form.title" placeholder="关键词"></el-input>
                </el-form-item>
                <el-form-item label="发帖人">
                    <el-input v-model="form.keywords" placeholder="发帖人"></el-input>
                </el-form-item>
            </el-form>
            <div >
                <el-button type="primary" size="medium" @click="editPosts({})">发帖</el-button>
            </div>
        </div>
        <div class="panel_body">
            <div v-for="p in posts" :key="p.id" class="item_block">
                <div class="fx fx-c_center info_row" style="border-bottom: 1px solid var(--border)">

                    <div style="width: 1200px;" >
                        <div class="lesson_name" style="margin-left: 5px;">
                            <h2>{{p.title}}</h2>
                        </div>
                        <div style="margin: 8px 0px;margin-left: 5px;"><img :src="p.avatar" alt="" style="width: 40px"><span style="position: relative;top: -12px;left: 13px;">{{p.userName}}</span></div>
                        <div style="margin-top:5px;margin-bottom: 10px;margin-left: 5px;" v-html="p.contentFormHtml">
                        </div>
                        <el-row>
                            <el-col :span="12">
                                <div class="grid-content bg-purple count_div">
                                    <span><i class="iconfont icon-dianzan"></i> {{p.favorCount}}点赞量</span>
                                    <span><i class="iconfont icon-yanjing"></i> {{p.viewCount}}阅读</span>
                                    <span><i class="iconfont icon-message"></i> {{p.commentCount}}评论</span>
                                </div>
                            </el-col>
                            <el-col :span="12"><div class="grid-content bg-purple-light">{{p.createTime}}</div></el-col>
                        </el-row>
                    </div>
                    <div class="fx-g1"></div>
                    <div>
                        <div style="width: 207px" class="fx fx-m_between fx-c_center">
                            <el-link type="primary" @click="toDetail(p)"
                                     :underline="false" ><i class="iconfont icon-yanjing"></i><b>查看</b></el-link>
                            <el-link type="primary" @click="editPosts(p)" v-if="uId == p.operatorId || enable "
                                     :underline="false" ><i class="iconfont icon-bianji"></i><b>编辑</b></el-link>
                            <el-popconfirm @onConfirm="delPosts(p.id)"  v-if="uId == p.operatorId || enable "
                                           title="确认删除吗？"
                            >
                                <el-link type="danger" slot="reference"
                                         :underline="false" ><i class="iconfont icon-shanchu"></i><b>删除</b></el-link>
                            </el-popconfirm>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="panel_foot fx fx-m_end fx-c_center">
            <el-pagination
                :background="true"
                prev-text="上一页"
                next-text="下一页"
                layout="prev, pager, next"
                :current-page="pager.currentPage"
                :page-size="pager.pageSize"
                :total="pager.dataTotal"
                @current-change="pageChange"
            >
            </el-pagination>
        </div>
        <PostsEditDrawer v-if="showPostsEdit" @submit="loadPosts"
                          @close="showPostsEdit=false" :item="currentPosts"></PostsEditDrawer>
    </div>
</template>

<style scoped>
    .panel_foot  {
        background-color: white;
    }
    .tip {
        padding:0 6px 0 12px;
    }
    .item_block {
        background: white;
        padding: 18px 50px;
        border-radius: 6px;
        margin-bottom: 10px;
    }
    .info_row>*:not(:first-child) {
        margin-left: 50px;
    }
    .count_div span{
        margin-right: 30px;
    }
    .count_div i{
        color: #00b7ee;
    }
    .coverimg {
        width: 160px;
    }
    .lesson_name {
        font-size: 16px;
        font-weight: bold;
        color: var(--dark);
    }
    .lesson_resource i.iconfont, .task_info i.iconfont {
        vertical-align: text-bottom;
    }

    .task_item {
        height: 50px;
        border-bottom: 1px solid var(--border);
    }
</style>
<style>

</style>
<script type="text/javascript" src="http://assets.program.leadersir.cn/scratch/lib.min.js" ></script>
<script type="text/javascript" src="http://assets.program.leadersir.cn/scratch/chunks/player.js" ></script>
<script>
    import PostsEditDrawer from "./PostsEditDrawer";
    import {mapMutations} from "vuex";
    export default {
        components: {
            PostsEditDrawer
        },
        props: [
        ],
        data() {
            return {
                loading: true,
                showPostsEdit: false,
                currentPosts: {},
                form:{keywords:''},
                posts: [],
                pager: {
                    pageSize: 12,
                    dataTotal: 0,
                    currentPage: 1
                },
                uId:0,
                enable:false,
            }
        },
        watch: {
            "form": {
                handler: function () {
                    //查询条件变了
                    this.loadPosts();
                },
                deep: true
            }
        },
        methods: {
            ...mapMutations(["openTab"]),
            //加载所有课
            loadPosts() {
                this.$ajaxPost("/posts/list",{form : this.form,pager: {...this.pager, dataTotal: 0}}, (data) => {
                    this.posts = data.result;
                    let {offset, ...pager} = data.pager;
                    this.pager = pager;
                    this.showPostsEdit = false;
                    this.loading = false;
                })
            },
            pageChange(page) {
                this.pager.currentPage = page;
                this.loadPosts();
            },
            editPosts(item) {
                this.currentPosts = {...item};
                this.showPostsEdit = true;
            },

            delPosts(id) {
                this.$ajaxGet("/posts/del/" + id, (data) => {
                    this.$showSuccess("操作成功");
                    this.loadPosts();
                })
            },
            toDetail(item){
                this.$ajaxGet("/posts/addViewCount/" + item.id, (data) => {
                    this.openTab({
                        funcKey: "school_page_posts_detail_manage",
                        title: "发帖管理",
                        allowDuplicate: true,
                        attr: {
                            item: item,
                            isSelf: true
                        }
                    });
                })
            },
        },
        created() {
            let user = JSON.parse(localStorage.getItem("user"));
            this.uId = user.id;
            this.enable = user.isPosts;
            this.loadPosts();
        }
    }
</script>
